import styled from 'styled-components';

export const ImagePlaceholder = styled.span<{ size: number }>`
  background-color: #3a645c;
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;

  > small {
    font-family: 'Proxima Nova', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
    margin: auto;
    text-align: center;
  }
`;
